import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LaptopIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LaptopIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M4.90644 18.8615C3.94585 18.8615 3.16406 18.0806 3.16406 17.12V16.7158C3.16406 16.4239 3.40088 16.187 3.69286 16.187H4.78185V7.41996C4.78185 6.45937 5.56269 5.67853 6.52233 5.67853H19.4571C20.4176 5.67853 21.1985 6.45937 21.1985 7.41996V16.187H22.2865C22.5785 16.187 22.8153 16.4238 22.8153 16.7158V17.12C22.8153 18.0806 22.0345 18.8615 21.0739 18.8615L4.90644 18.8615ZM4.23402 17.2446C4.29204 17.5651 4.56975 17.8048 4.90644 17.8048H21.0739C21.4096 17.8048 21.6873 17.5661 21.7463 17.2446H15.1895L14.9803 17.4938C14.8833 17.5927 14.7473 17.6488 14.6065 17.6488H11.3728C11.2321 17.6488 11.0951 17.5927 10.9991 17.4938L10.7213 17.2171L4.23402 17.2446ZM20.1409 16.187V7.41996C20.1409 7.04333 19.8337 6.73613 19.457 6.73613H6.52233C6.1457 6.73613 5.8385 7.04333 5.8385 7.41996V16.187L20.1409 16.187Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LaptopIcon;
